import { TextField } from '@mui/material';

interface Props {
  label: string;
  value: any;
  name: string;
  className?: string;
  error?: string;
  hasError?: boolean;
  disabled?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  type?: string;
}

export const InputDate = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled = false,
}: Props) => {
  return (
    <>
      <TextField
        size='small'
        type={'date'}
        fullWidth
        label={label}
        value={value}
        name={name}
        InputLabelProps={{ shrink: true }}
        className={className}
        error={hasError}
        helperText={error}
        onBlur={handleBlur}
        onChange={handleChange}
        disabled={disabled}
      />
      {/*<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={pt} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>*/}
      {/*  <DatePicker*/}
      {/*      label={label}*/}
      {/*      name={name}*/}
      {/*      className={className}*/}
      {/*      format='DD/MM/YYYY'*/}
      {/*      onChange={handleChange}*/}
      {/*      value={value}*/}
      {/*  />*/}
      {/*</LocalizationProvider>*/}
    </>
  );
};
